import Toastify from "toastify-js";

class Product {
    constructor(element) {
        this.el = element;

        this.init();
    }

    
    init() {
        this.el.addEventListener("success", function (e) {
            const items = e.detail;
            console.log("success", items);

            //spektrix only returns ALL the items in the basket, so we can't easily show just the ones that have been added.

            const message = document.createElement("div");
            message.className = "success-message";

            const messageText = document.createElement("p");
            messageText.textContent = "Added to your basket";
            message.appendChild(messageText);

            Toastify({
                node: message,
                className: "is-success",
                duration: 3000,
                close: true,
                gravity: "bottom",
                position: "right",
                stopOnFocus: true,
            }).showToast();
            
        });

        this.el.addEventListener("fail", function (e) {
            console.log("fail", e);

            const errorMessage = document.createElement("div");
            errorMessage.className = "error-message";

            const messageText = document.createElement("p");
            messageText.textContent = e.detail.message || "An error occurred.";
            errorMessage.appendChild(messageText);

            if (e.detail.problems && e.detail.problems.length > 0) {
                const problemsList = document.createElement("ul");
                problemsList.role = "list";

                e.detail.problems.forEach((problem) => {
                    const listItem = document.createElement("li");
                    listItem.textContent = problem;
                    problemsList.appendChild(listItem);
                });
                
                errorMessage.appendChild(problemsList);
            }

            Toastify({
                node: errorMessage,
                className: "is-fail",
                duration: 3000,
                close: true,
                gravity: "bottom",
                position: "right",
                stopOnFocus: true,
            }).showToast();
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const products = document.querySelectorAll("spektrix-merchandise");

    products.forEach((element) => {
        new Product(element);
    });
});

export default Product;
